import Router from 'vue-router'
import Vue from 'vue'

import Layout from '@/components/navbar'
import AutoLogout from '@/components/auto-logout'

import auth from '@/middleware/auth'
import store from '@/store'
// import customizeRoutes from '@/router/customize'

const { VUE_APP_CUSTOMIZE_PROJECT, VUE_APP_CUSTOMIZE_API_LOG } = process.env

Vue.use(Router)

let customizeRoutes = []
if (VUE_APP_CUSTOMIZE_PROJECT) {
  try {
    const extend = require(`../customize/${VUE_APP_CUSTOMIZE_PROJECT}/router`)
    customizeRoutes = extend ? extend.default : []
  } catch {}
}

const defaultRoutes = [
  //////////////////////////// Page ////////////////////////////
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/page/login'),
    meta: {},
    hidden: true
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('@/views/page/forgot_password'),
    hidden: true
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/page/404'),
    hidden: true
  },
  { path: '*', redirect: '/404', hidden: true },
  {
    path: '/',
    redirect: '/realtime',
    meta: {
      expansion: false
    }
  },
  {
    path: '/status',
    name: 'Serive status',
    component: () => import('@/views/page/status'),
    hidden: true,
    meta: {
      title: 'System status',
      page: 'Information - System status',
      middleware: [auth]
    }
  },
  {
    path: '/realtime_old',
    component: Layout,
    hidden: true,
    meta: {
      title: 'Realtime old',
      icon: 'fa-chart-line',
      expansion: false
    },
    children: [
      {
        path: '',
        name: 'Realtime old',
        component: () => import('@/views/realtime_old/index'),
        meta: { page: 'Realtime old' }
      }
    ]
  },
  {
    path: '/dashboard_old',
    component: Layout,
    hidden: true,
    meta: {
      title: 'Dashboards old',
      icon: 'fa-th-large',
      expansion: true
    },
    children: [
      {
        path: 'voice_inbound',
        name: 'Voice inbound old',
        component: () => import('@/views/dashboard_old/voice_inbound'),
        meta: {
          title: 'Voice inbound old',
          page: 'Dashboards - Voice inbound old'
        }
      },
      {
        path: 'voice_outbound',
        name: 'Voice outbound old',
        component: () => import('@/views/dashboard_old/voice_outbound'),
        meta: {
          title: 'Voice outbound old',
          page: 'Dashboards - Voice outbound old'
        }
      },
      {
        path: 'chat_inbound',
        name: 'Chat inbound old',
        component: () => import('@/views/dashboard_old/chat_inbound'),
        meta: {
          title: 'Chat inbound old',
          page: 'Dashboards - Chat inbound old'
        }
      }
    ]
  },

  //////////////////////////// Layout ////////////////////////////
  // reporting
  {
    path: '/realtime',
    component: Layout,
    meta: {
      title: 'Realtime',
      icon: 'fa-chart-line',
      expansion: false
    },
    children: [
      {
        path: '',
        name: 'Realtime',
        component: () => import('@/views/realtime/index'),
        meta: { page: 'Realtime', middleware: [auth] }
      }
    ]
  },
  {
    path: '/dashboard',
    component: Layout,
    meta: {
      title: 'Dashboards',
      icon: 'fa-th-large',
      expansion: true
    },
    children: [
      {
        path: 'voice_inbound',
        name: 'Voice inbound',
        component: () => import('@/views/dashboard/voice_inbound'),
        meta: {
          title: 'Voice inbound',
          page: 'Dashboards - Voice inbound',
          middleware: [auth]
        }
      },
      {
        path: 'voice_outbound',
        name: 'Voice outbound',
        component: () => import('@/views/dashboard_old/voice_outbound'),
        meta: {
          title: 'Voice outbound',
          page: 'Dashboards - Voice outbound',
          middleware: [auth]
        }
      },
      {
        path: 'chat_inbound',
        name: 'Chat inbound',
        component: () => import('@/views/dashboard_old/chat_inbound'),
        meta: {
          title: 'Chat inbound',
          page: 'Dashboards - Chat inbound',
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/insights',
    component: Layout,
    meta: {
      title: 'Insights',
      icon: 'fa-lightbulb',
      expansion: false
    },
    children: [
      {
        path: '',
        name: 'Insights',
        component: () => import('@/views/insight/index'),
        meta: { page: 'Insight', middleware: [auth] }
      }
    ]
  },
  {
    path: '/reports',
    component: Layout,
    meta: {
      title: 'Reports',
      icon: 'fa-file-alt',
      expansion: false
    },
    children: [
      {
        path: '',
        name: 'Reports',
        component: () => import('@/views/report/index'),
        meta: { page: 'Reports', middleware: [auth] }
      }
    ]
  },
  { path: '', divider: true },

  // sessions
  {
    path: '/conversations',
    component: Layout,
    meta: {
      title: 'Conversations',
      icon: 'fa-comments',
      expansion: false
    },
    children: [
      {
        path: '',
        name: 'Conversations',
        component: () => import('@/views/conversation/index'),
        meta: { page: 'Conversations', middleware: [auth] }
      }
    ]
  },
  {
    path: '/agent',
    component: Layout,
    meta: {
      title: 'Live agent',
      icon: 'fa-headset',
      expansion: false
    },
    children: [
      {
        path: '',
        name: 'Live agent',
        component: () => import('@/views/agent/chat'),
        meta: {
          title: 'Live agent',
          page: 'Live agent',
          middleware: [auth]
        }
      }
    ]
  },
  { path: '', divider: true },

  // bot
  {
    path: '/channels',
    component: Layout,
    meta: {
      title: 'Channels',
      icon: 'fa-arrows-to-circle',
      expansion: false
    },
    children: [
      {
        path: '',
        name: 'Channels',
        component: () => import('@/views/channels/index'),
        meta: {
          title: 'Channels',
          page: 'Channels',
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/campaign',
    component: Layout,
    meta: {
      title: 'Campaigns',
      icon: 'fa-bullhorn',
      expansion: false
    },
    children: [
      {
        path: '',
        name: 'Campaign Voice',
        component: () => import('@/views/campaign/voice/index'),
        meta: {
          title: 'Voice campaign',
          page: 'Campaigns',
          middleware: [auth]
        }
      },
      {
        path: 'voice/phone_list/:id',
        name: 'Campaign Voice Phone List',
        component: () =>
          import('@/views/campaign/voice/voice_phone_list/index'),
        meta: {
          title: 'Campaign Voice Phone List',
          page: 'Campaigns',
          middleware: [auth],
          hidden: true
        }
      }
    ]
  },
  {
    path: '/flows',
    component: Layout,
    meta: {
      title: 'Flows',
      icon: 'fa-pencil-ruler',
      expansion: false
    },
    children: [
      {
        path: '',
        name: 'Flows',
        component: () => import('@/views/flow/index'), //import('@/views/flow_builder/voice/index'),
        meta: {
          title: 'Flows',
          page: 'Flows',
          middleware: [auth]
        }
      },
      {
        path: 'builder/:id',
        name: 'Flows builder',
        component: () => import('@/views/flow/builder/index'),
        meta: {
          title: 'Flows builder',
          page: 'Flows',
          middleware: [auth],
          hidden: true
        }
      }
    ]
  },
  // {
  //   path: '/bot',
  //   component: Layout,
  //   meta: {
  //     title: 'Brain',
  //     icon: 'fa-brain',
  //     expansion: true
  //   },
  //   children: [
  //     {
  //       path: 'intents',
  //       name: 'Intents',
  //       component: () => import('@/views/nlu/intents/index'),
  //       meta: {
  //         title: 'Intents',
  //         page: 'Brain - Intents',
  //         middleware: [auth]
  //       }
  //     },
  //     {
  //       path: 'entities',
  //       name: 'Entities',
  //       component: () => import('@/views/nlu/entities/index'),
  //       meta: {
  //         title: 'Entities',
  //         page: 'Brain - Entities',
  //         middleware: [auth]
  //       }
  //     },
  //     {
  //       path: 'dictionary',
  //       name: 'Dictionary',
  //       component: () => import('@/views/nlu/dictionary/index'),
  //       meta: {
  //         title: 'Dictionary',
  //         page: 'Brain - Dictionary',
  //         middleware: [auth]
  //       }
  //     },
  //     {
  //       path: 'qc_review',
  //       name: 'QC Review',
  //       component: () => import('@/views/nlu/qc_review/index'),
  //       meta: {
  //         title: 'QC Review',
  //         page: 'Brain - QC Review',
  //         middleware: [auth]
  //       }
  //     },
  //     {
  //       path: 'nlu',
  //       name: 'NLU',
  //       component: () => import('@/views/nlu/nlu/index'),
  //       meta: {
  //         title: 'NLU',
  //         page: 'Brain - NLU',
  //         middleware: [auth]
  //       }
  //     }
  //     // ปิดหน้า Q&A เพราะไม่ได้ใช้ (cf by p'tul)
  //     // {
  //     //   path: 'q_and_a',
  //     //   name: 'Q&A',
  //     //   component: () => import('@/views/nlu/q_and_a/index'),
  //     //   meta: {
  //     //     title: 'Q&A',
  //     //     page: 'Brain - Q&A',
  //     //     middleware: [auth]
  //     //   }
  //     // }
  //   ]
  // },

  {
    path: '/nlu/model',
    component: Layout,
    meta: {
      title: 'NLU',
      icon: 'fa-brain',
      expansion: false
    },
    children: [
      {
        path: '',
        name: 'NLU - Model',
        component: () => import('@/views/nlu/model'),
        meta: { page: 'NLU', middleware: [auth] }
      },
      {
        path: '/nlu/model/:model_name/entity',
        name: 'NLU - Entity',
        component: () => import('@/views/nlu/entity'),
        meta: { page: 'NLU', middleware: [auth] }
      },
      {
        path: '/nlu/model/:model_name/intent',
        name: 'NLU - Intent',
        component: () => import('@/views/nlu/intent'),
        meta: { page: 'NLU', middleware: [auth] }
      },
      {
        path: '/nlu/model/:model_name/tagging',
        name: 'NLU - Tagging',
        component: () => import('@/views/nlu/tagging'),
        meta: { page: 'NLU', middleware: [auth] }
      },
      {
        path: '/nlu/model/:model_name/testing-data',
        name: 'NLU - Testset',
        component: () => import('@/views/nlu/testset'),
        meta: { page: 'NLU', middleware: [auth] }
      },
      {
        path: '/nlu/model/:model_name/qc',
        name: 'NLU - QC',
        component: () => import('@/views/nlu/qc'),
        meta: { page: 'NLU', middleware: [auth] }
      }
    ]
  },
  // ------------------ Use for Gen ------------
  {
    path: '/gen_ai',
    component: Layout,
    meta: {
      title: 'Gen AI',
      icon: 'mdi-creation',
      expansion: false
    },
    children: [
      {
        path: '',
        name: 'Gen AI',
        component: () => import('@/views/gen_ai/index'),
        meta: { page: 'Gen AI', middleware: [auth] }
      }
    ]
  },
  // ------------------End  Use for Gen ------------
  {
    path: '/tests',
    component: Layout,
    meta: {
      title: 'Tests',
      icon: 'far fa-check-circle',
      expansion: true
    },
    children: [
      {
        path: 'test_scripts',
        name: 'Test scripts',
        component: () => import('@/views/test/test_scripts/index'),
        meta: {
          title: 'Test scripts',
          page: 'Tests - Test scripts',
          middleware: [auth]
        }
      },
      {
        path: 'test_runs',
        name: 'Test runs',
        component: () => import('@/views/test/test_runs/index'),
        meta: {
          title: 'Test runs',
          page: 'Tests - Test runs',
          middleware: [auth]
        }
      }
    ]
  },
  { path: '', divider: true },
  {
    path: '/settings',
    component: Layout,
    meta: {
      title: 'Settings',
      icon: 'fa-cog',
      expansion: true
    },
    children: [
      {
        path: 'system-settings',
        name: 'System Settings',
        component: () => import('@/views/setting/system_settings/index'),
        meta: {
          title: 'System settings',
          page: 'Settings - System settings',
          middleware: [auth]
        }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/setting/users_management/index'),
        meta: { title: 'Users', page: 'Settings - Users', middleware: [auth] }
      },
      {
        path: 'roles',
        name: 'Roles',
        component: () => import('@/views/setting/roles_management/index'),
        meta: { title: 'Roles', page: 'Settings - Roles', middleware: [auth] }
      },
      {
        path: 'queues',
        name: 'Queues',
        component: () => import('@/views/setting/queues/index'),
        meta: { title: 'Queues', page: 'Settings - Queues', middleware: [auth] }
      },
      {
        path: 'audit-log',
        name: 'Audit Log',
        component: () => import('@/views/setting/audit_log/index'),
        meta: {
          title: 'Audit log',
          page: 'Settings - Audit log',
          middleware: [auth]
        }
      },
      {
        path: 'api-log',
        name: 'API Log',
        component: () => import('@/views/setting/api_log/index'),
        meta: {
          title: VUE_APP_CUSTOMIZE_API_LOG || 'API log',
          page: 'Settings - API log',
          middleware: [auth]
        }
      },
      { path: '', divider: true },
      {
        path: 'audios',
        name: 'Audios',
        component: () => import('@/views/setting/audio/index'),
        meta: {
          title: 'Audios',
          page: 'Settings - Audios',
          middleware: [auth]
        }
      },
      {
        path: 'images',
        name: 'Images',
        component: () => import('@/views/setting/image/index'),
        meta: {
          title: 'Images',
          page: 'Settings - Images',
          middleware: [auth]
        }
      },
      {
        path: 'videos',
        name: 'Videos',
        component: () => import('@/views/setting/video/index'),
        meta: {
          title: 'Videos',
          page: 'Settings - Videos',
          middleware: [auth]
        }
      },
      {
        path: 'grammars',
        name: 'Grammars',
        component: () => import('@/views/setting/grammar/index'),
        meta: {
          title: 'Grammars',
          page: 'Settings - Grammars',
          middleware: [auth]
        }
      },
      {
        path: 'tts_dictionaries',
        name: 'TTS dictionaries',
        component: () => import('@/views/setting/tts_dictionaries/index'),
        meta: {
          title: 'TTS dictionaries',
          page: 'Settings - TTS dictionaries',
          middleware: [auth]
        }
      },
      {
        path: 'fields',
        name: 'Fields',
        component: () => import('@/views/setting/field/index'),
        meta: {
          title: 'Fields',
          page: 'Settings - Fields',
          middleware: [auth]
        }
      },
      {
        path: 'contacts',
        name: 'Contacts',
        component: () => import('@/views/setting/contacts_management/index'),
        meta: {
          title: 'Contacts',
          page: 'Settings - Contacts',
          middleware: [auth]
        }
      },
      {
        path: 'holidays',
        name: 'Holidays',
        component: () => import('@/views/setting/holidays/index'),
        meta: {
          title: 'Holidays',
          page: 'Settings - Holidays',
          middleware: [auth]
        }
      },
      {
        path: 'schedules',
        name: 'Schedules',
        component: () => import('@/views/setting/schedules/index'),
        meta: {
          title: 'Schedules',
          page: 'Settings - Schedules',
          middleware: [auth]
        }
      },
      {
        path: 'key_value_explorer',
        name: 'Key value explorer',
        component: () => import('@/views/setting/key_value_explorer/index'),
        meta: {
          title: 'Key value explorer',
          page: 'Settings - Key value explorer',
          middleware: [auth]
        }
      },
      {
        path: 'lookup_tables',
        name: 'Lookup tables',
        component: () => import('@/views/setting/lookup_tables/index'),
        meta: {
          title: 'Lookup tables',
          page: 'Settings - Lookup tables',
          middleware: [auth]
        }
      },
      {
        path: 'lookup_tables/:id',
        name: 'Lookup tables - Table',
        component: () => import('@/views/setting/lookup_tables/table/index'),
        meta: {
          title: 'Lookup tables - Table',
          page: 'Settings - Lookup tables',
          middleware: [auth],
          hidden: true
        }
      }
    ]
  },

  //////////////////////////// Dev ////////////////////////////
  {
    path: '',
    component: AutoLogout,
    meta: {},
    children: [
      {
        path: 'nlu_test_history',
        name: 'NluTestHistory',
        component: () => import('@/views/page/nlu_test_history')
      },
      {
        path: 'nlu_test_result',
        name: 'NluTestResult',
        component: () => import('@/views/page/nlu_test_result')
      },
      {
        path: 'version',
        name: 'Version',
        component: () => import('@/views/page/version')
      },
      {
        path: 'component',
        name: 'Component',
        component: () => import('@/views/page/component')
      },
      {
        path: 'treeview',
        name: 'Treeview',
        component: () => import('@/views/page/tree/index')
      },
      {
        path: 'session_log',
        name: 'SessionLog',
        component: () => import('@/views/page/session_log')
      }
    ],
    props: true,
    hidden: true
  }
]

export const constantRoutes = defaultRoutes.concat(customizeRoutes)

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next()
  }

  const middleware = to.meta.middleware

  const context = {
    to,
    from,
    next,
    store,
    router
  }
  return middleware[0]({
    ...context
  })
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
